import React from 'react';

interface FilterIconProps {
  isActive: boolean;
  onClick: () => void;
  title?: string;
  size?: 'sm' | 'md';
}

const FilterIcon: React.FC<FilterIconProps> = ({ 
  isActive, 
  onClick, 
  title = "Filter Settings",
  size = 'md'
}) => {
  const iconSize = size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';
  
  return (
    <button
      onClick={onClick}
      className={`p-1 rounded transition-colors ${
        isActive
          ? 'text-amber-500 hover:text-amber-400' 
          : 'text-gray-500 hover:text-gray-400'
      }`}
      title={title}
    >
      <svg className={iconSize} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 1 0 013 6.5V4z" />
      </svg>
    </button>
  );
};

export default FilterIcon;
